import React from 'react';
import {IAvailableScope} from '../../../Interfaces/interfaces';
import PermissionItem from './PermissionItem/PermissionItem';
import {DetailWrapper,} from '../../../Shared/styles';
import {Values} from "Tools/Values";
import DetailTitleRow from '../DetailTitleRow/DetailTitleRow';

interface IOptionalPermissionProps {
    permissions: IAvailableScope[];
    isOptional?: boolean;
}

const AppPermissions = ({permissions, isOptional}: IOptionalPermissionProps) => (
    <DetailWrapper>
        <DetailTitleRow title={Values.getLocalizationValue(isOptional ? 'optionalPermissions' : 'requiredPermissions')}/>

        {permissions?.map((permission) => (
            <PermissionItem
                appName={permission.targetAppDisplayName}
                scope={permission}
                isOptional={isOptional}
                key={permission.id}
            />
        ))}
    </DetailWrapper>
)

export default AppPermissions;
